import { useCardSurface } from '@littlebird/action-cards-view/react';

export function useCardMetrics() {
  const surface = useCardSurface();
  const mobile = surface.startsWith('mobile_');
  const preview =
    surface === 'web_home' ||
    surface === 'web_feeds' ||
    surface === 'mobile_home';
  return {
    mobile,
    preview,
    // A long body scrolls past about 12 lines in chat and 6 in a preview
    bodyMaxHeight: preview ? 'max-h-[6lh]' : 'max-h-[12lh]',
  };
}
